import { InjectionToken } from '@angular/core';

export const HANDLE_META = new InjectionToken<() => void>('handleMeta');
